import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '../../../app/core/utils';

@Pipe({
  name: 'pascalToSentence'
})
export class PascalToSentencePipe implements PipeTransform {

  // CaseLikeThis => Case Like This
  // caseListTike => case Like This

  transform(value: string, ...args: any[]): string {
    if (isNullOrUndefined(value)) {
      return '';
    }

    if (value.length) {
      const result = value.split('').map(char => {
        if (char.toUpperCase() === char) {
          return ' ' + char;
        } else {
          return char;
        }
      }).join('');
      return result;
    }
    return value;
  }

}
